import styled, { css } from 'styled-components';

export const ProjectDiv = styled.article`
  visibility: visible;
  opacity: 1;
  transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  transition: opacity 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s,
    transform 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;
  display: grid;
  gap: 0.625rem;
  grid-template-columns: repeat(12, 1fr);
  -moz-box-align: center;
  align-items: center;

  .project-content-right,
  .project-content-left {
    position: relative;
    grid-area: 1 / 1 / -1 / 7;

    .project-overline {
      margin: 10px 0px;
      color: #3bcfe3;
      font-size: 0.8125rem;
      font-weight: 400;
    }

    .project-title {
      margin-bottom: 1rem;

      &:hover {
        color: #3bcfe3;
      }
    }

    .project-description {
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      box-shadow: 0 10px 30px -10px rgba(2, 12, 27, 0.7);
      position: relative;
      z-index: 2;
      padding: 1.5625rem;
      border-radius: 0.3125rem;
      background-color: #034063;
      color: #D6D6D6;
      font-size: clamp(1rem, 2.5vw, 1.2rem); ;
      font-size: clamp(0.9rem, 2.5vw, 1rem); 
      line-height: 1.3;
      text-align: justify;

      @media (max-width: 1160px) {
        padding: 1.2rem;
        font-size: 0.9rem;
      }
      @media (max-width: 758px) {
        padding: 1.5rem;
      }
      @media (max-width: 500px) {
        padding: 1rem;
      }
    }

    .project-tech-list {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 0.4rem;
      position: relative;
      z-index: 2;
      margin: 25px 0px 10px;
      padding: 0px;
      list-style: none;
      color: #3bcfe3;
      font-weight: bold;
      font-size: 0.9rem;

      @media (max-width: 1160px) {
        margin: 20px 0px 5px;
        font-size: 0.8rem;
      }
    }
    .project-links {
      display: flex;
      grid-gap: 1rem;
      -moz-box-align: center;
      align-items: center;
      position: relative;
      margin-top: 10px;
      color: #ccd6f6;

      a {
        display: flex;
        grid-gap: 0.6rem;
        margin-top: 0.5rem;
        align-items: flex-end;
        text-decoration: none;

        svg {
          width: 1.4rem;
          filter: invert(57%) sepia(7%) saturate(8%) hue-rotate(131deg)
            brightness(96%) contrast(90%);
        }
        p {
          color: #D6D6D6;
        }
        &:hover {
          filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
            brightness(91%) contrast(95%);
        }
      }
      @media (max-width: 1160px) {
        margin-top: 5px;

        a {
          grid-gap: 0.4rem;
        }
        svg {
          width: 1.2rem;
        }
        p {
          font-size: 0.85rem;
        }
      }
      @media (max-width: 500px) {
        margin-top: 2px;
        svg {
          width: 0.9rem;
        }
      }
    }
    .project-title {
      font-size: clamp(24px, 5vw, 28px);
      font-weight: 600;
      line-height: 1.1;
      color: #fff;

      a {
        position: static;
        display: inline-block;
        text-decoration: none;
        text-decoration-skip-ink: auto;
        color: inherit;
        position: relative;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      @media (max-width: 500px) {
        font-size: clamp(18px, 5vw, 20px);
      }
    }
  }

  .project-content-left {
    grid-column: 7 / -1;
    text-align: right;
    z-index: 2;
    transform: translate(30%, 30%);
    opacity: 0;
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);

    .project-tech-list,
    .project-links {
      justify-content: flex-end;
    }

    @media (max-width: 758px) {
      text-align: left;

      .project-tech-list,
      .project-links {
        justify-content: flex-start;
      }
    }

    ${({ isInView }) =>
      isInView &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
        opacity: 1;
      `}
  }

  .project-content-right {
    z-index: 2;
    opacity: 0;
    transform: translate(-30%, 30%);
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    ${({ isInView }) =>
      isInView &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
        opacity: 1;
      `}
  }

  .project-image-right,
  .project-image-left {
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    grid-area: 1 / 6 / -1 / -1;
    position: relative;
    overflow: hidden;
    z-index: 1;
    height: 23rem;
    border-radius: 4px;

    img {
      transition: transform 1s cubic-bezier(0.645, 0.045, 0.355, 1);
      border-radius: 4px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .project-overlay {
      position: absolute;
      transition: background linear 0.7s;
      width: 100%;
      height: 100%;
      top: 0;
      background-color: rgb(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;

      .view {
        background-color: #3bcfe3;
        transition: all ease 0.5s;
        transition-delay: 0.4s;
        transform: scale(0.5);
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        text-align: center;
        opacity: 0;
        cursor: pointer;
        font-size: 0.8rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 1rem;
          height: 0.8rem;
          filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(265deg)
            brightness(105%) contrast(100%);
          margin-top: 0.4rem;
        }
        p {
          margin-top: 0.3rem;
          color: #fff;
        }
      }
    }

    &:hover .project-overlay {
      background-color: rgb(1, 26, 40, 0);
    }

    &:hover img {
      transform: scale(1.1);
    }

    &:hover .project-overlay .view {
      display: flex;
      opacity: 1;
      transform: scale(1);
    }
    @media (max-width: 1325px) {
      height: 18rem;
    }
    @media (max-width: 1160px) {
      height: 18rem;
    }
    @media (max-width: 1145px) {
      height: 16rem;
    }
    @media (max-width: 1024px) {
      height: 14rem;
    }
    @media (max-width: 758px) {
      height: 22rem;
    }
    @media (max-width: 670px) {
      height: 20rem;
    }
    @media (max-width: 585px) {
      height: 18rem;
    }
    @media (max-width: 560px) {
      height: 16rem;
    }
    @media (max-width: 500px) {
      height: 12rem;
    }
    @media (max-width: 400px) {
      height: 10rem;
    }
    @media (max-width: 350px) {
      height: 9rem;
    }
  }
  .project-image-left {
    grid-column: 1 / 8;
    transform: translate(-30%, 30%);
    opacity: 0;
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    ${({ isVisible }) =>
      isVisible &&
      css`
        opacity: 1;
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
      `}
  }
  .project-image-right {
    transform: translate(30%, 30%);
    opacity: 0;
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    ${({ isVisible }) =>
      isVisible &&
      css`
        opacity: 1;
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
      `}
  }

  @media (max-width: 758px) {
    display: block;
  }
`;
